import truck from "../../../assests/images/truckicon.svg";
import plane from "../../../assests/images/calculaterAirIcon.svg";

export function listOfServies(details, tatService) {
  let serivesSurat = [
    {
      id: 1,
      serive: "Standard",
      servicesIcon: truck,
      color: "blue",
      price: details?.standareSurface,
      modeName: "surface",
      tatService: tatService?.result?.data?.standardSurface,
    },
    {
      id: 2,
      serive: "Standard",
      servicesIcon: plane,
      color: "blue",
      price: details?.standareAir,
      modeName: "air",
      tatService: tatService?.result?.data?.standardAir,
    },
    {
      id: 3,
      serive: "Fast Track",
      servicesIcon: truck,
      color: "orange",
      price: details?.fastSurface,
      modeName: "surface",
      tatService: tatService?.result?.data?.expressSurface,
    },
    {
      id: 4,
      serive: "Fast Track",
      servicesIcon: plane,
      color: "orange",
      price: details?.fastAir,
      modeName: "air",
      tatService: tatService?.result?.data?.expressAir,
    },
    {
      id: 5,
      serive: "Value Plus",
      servicesIcon: truck,
      color: "green",
      price: details?.valueAir,
      modeName: "surface",
      tatService: tatService?.result?.data?.valueSurface,
    },
    {
      id: 6,
      serive: "Value Plus",
      servicesIcon: plane,
      color: "green",
      price: details?.valueSurface,
      modeName: "air",
      tatService: tatService?.result?.data?.valueAir,
    },
  ];

  let allserives = [
    {
      id: 1,
      serive: "Standard",
      servicesIcon: truck,
      color: "blue",
      price: details?.standareSurface,
      modeName: "surface",
      tatService: tatService?.result?.data?.standardSurface,
    },
    {
      id: 2,
      serive: "Standard",
      servicesIcon: plane,
      color: "blue",
      price: details?.standareAir,
      modeName: "air",
      tatService: tatService?.result?.data?.standardAir,
    },
    {
      id: 3,
      serive: "Fast Track",
      servicesIcon: truck,
      color: "orange",
      price: details?.fastSurface,
      modeName: "surface",
      tatService: tatService?.result?.data?.expressSurface,
    },
    {
      id: 4,
      serive: "Fast Track",
      servicesIcon: plane,
      color: "orange",
      price: details?.fastAir,
      modeName: "air",
      tatService: tatService?.result?.data?.expressAir,
    },
  ];
  return { allserives, serivesSurat };
}
